import * as React from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements, ElementsConsumer } from '@stripe/react-stripe-js';

const PaymentHOC = (WrappedComponent) => {
    const promise = loadStripe(process.env.STRIPE_TOKEN_CLIENT);
    class HOC extends React.Component {
        render() {
            return (
                <Elements stripe={promise}>
                    <ElementsConsumer>
                        {({ stripe, elements }) => (
                            <WrappedComponent
                                {...this.props}
                                stripe={stripe}
                                elements={elements}
                            />
                        )}
                    </ElementsConsumer>
                </Elements>
            );
        }
    }
    return HOC;
};

export default PaymentHOC;
